import { render, staticRenderFns } from "./expertsDetail.vue?vue&type=template&id=2c29c868&scoped=true"
import script from "./expertsDetail.vue?vue&type=script&lang=js"
export * from "./expertsDetail.vue?vue&type=script&lang=js"
import style0 from "./expertsDetail.vue?vue&type=style&index=0&id=2c29c868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29c868",
  null
  
)

export default component.exports